/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Finish_Events_ParagraphInputs */

const en_register_onboarding_finish_events_paragraph = /** @type {(inputs: Register_Onboarding_Finish_Events_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the events in our program to prepare for interviews or further applications and to learn new skills.`)
};

const de_register_onboarding_finish_events_paragraph = /** @type {(inputs: Register_Onboarding_Finish_Events_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze die Veranstaltungen in unserem Programm, um dich auf Gespräche oder weitere Bewerbungen vorzubereiten und neue Fähigkeiten zu lernen.`)
};

/**
* | output |
* | --- |
* | "Use the events in our program to prepare for interviews or further applications and to learn new skills." |
*
* @param {Register_Onboarding_Finish_Events_ParagraphInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_finish_events_paragraph = /** @type {((inputs?: Register_Onboarding_Finish_Events_ParagraphInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Finish_Events_ParagraphInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_finish_events_paragraph(inputs)
	return en_register_onboarding_finish_events_paragraph(inputs)
});